<template>
  <div>
    <van-radio-group v-model="dateType" @change="radioChange" class='radio-group'>
      <van-radio name="0" class="radio-li">全部</van-radio>
      <van-radio name="1" class="radio-li">7天</van-radio>
      <van-radio name="2" class="radio-li">15天</van-radio>
      <van-radio name="3" class="radio-li">30天</van-radio>
      <van-radio name="4" class="radio-li">一学期</van-radio>
    </van-radio-group>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadList">
         <div v-for="item in pageList" :key="item.ClassroomRecordID" class="xy-list">
          <div class="builds-flex">
            <div class="build-name nowrap builds"> {{ item.SchoolDistrictName }}</div>
            <div class="build-mark builds">
                <span class="nowrap">{{item.TeacherFullName }}</span>
                <span class="nowrap">{{item.DisciplineName }}</span>
            </div>
          </div>
          <div>
            <div class="build-mark-name">
               <span>{{ item.WeekName }}</span>
               <span class="cut-line">|</span>
               <span>{{ item.DayTimeName }}</span>
               <span class="cut-line">|</span>
               <span>{{ item.LastModifyByDateName }}</span>
            </div>
            <div class="build-mark-name">
               <span class="cut-line">{{ item.StudentYearName }}</span>
              <span class="cut-line">{{ item.StudentGradeName }}</span>
              <span class="cut-line">{{ item.StudentOrganizationName }}</span>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
//  import { setTimeout } from "timers";
 import xyapi from "@/common/api";
export default {
  data() {
    return {
      page: 1,
      pageSize: 15,
      pageList: [],
      loading: false, // 是否加载中
      finished: false, // 加载是否完成
      isLoading: false, //是否处于下拉刷新状态
      //表头查询相关
      dateType: '0',
      startTime: '',
      endTime: '',
      searchText: '',
      currentAcademicSession: {},//当前学年
    };
  },
  created() {
      this.getCurrentAcademicSession();
      this.loadList();
  },
  mounted() {

  },
  methods: {
   async loadList() {
      this.xy.loading();
      let res = await xyapi.get(`${this.$store.state.apiPath}/api/ClassroomRecord/GetPageList`, {
        startTime: this.startTime,
        endTime: this.endTime,
        pageIndex: this.page,
        pageSize: this.pageSize,
        searchText: this.searchText,
      });
      this.xy.unloading();
      if (res.success) {
          let list = res.data.data;
          this.pageList = [...this.pageList, ...list];
          this.loading = false;
          this.page++;
          this.finished =(this.pageList.length >= res.data.totalRecords) ? true : false;
      }
    },

    onRefresh() {
      setTimeout(() => {
        this.pageList = [];
        this.page = 1;
        this.isLoading = false;
        this.loadList();
      }, 500);
    },
     //获取当前学期
    async getCurrentAcademicSession () {
      this.xy.loading();
      let res = await xyapi.get(`${this.$store.state.apiPath}/api/ClassroomRecord/GetCurrentAcademicSession`);
      this.xy.unloading();
      if (res.success) {
          this.currentAcademicSession = res.data;
      }
    },

    radioChange(val) {
      this.dateType =val;
      this.pageList = [];
      //let toDay = new Date();
      //由于查询语句,between and 后的日期是时间区间不包括右边界的，所有endTime + 1
      this.endTime = this.xy.moment().add(1, 'd').format("YYYY-MM-DD");
      if (val === "0") {//全部
          this.startTime = null;
          this.endTime = null;
      } else if (val === "1") {//7天
          this.startTime =  this.xy.moment().subtract(6, 'd').format("YYYY-MM-DD");
      } else if (val === "2") {//15天
          this.startTime = this.xy.moment().subtract(14, 'd').format("YYYY-MM-DD"); 
      } else if (val === "3") {//30天
          this.startTime = this.xy.moment().subtract(29, 'd').format("YYYY-MM-DD"); 
      } else if (val === "4") {//学期
          this.startTime = this.xy.moment(this.currentAcademicSession.StartDate).format("YYYY-MM-DD");
          this.endTime = this.xy.moment(this.currentAcademicSession.EndDate).format("YYYY-MM-DD");
      }
      this.page = 1;
      this.onRefresh();
    },
  }
};
</script>
<style lang="less" scoped>
.radio-group{
  display: flex;
  justify-content: center;
  background: #fff;
  height: 80px;
  .radio-li{
    margin: 0 4px;
  }
}
.xy-list {
  background: #ffffff;
  height: 150px;
  margin: 18px;
  border-radius: 12px;
  padding: 0 18px;
}
.builds-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .builds {
    height: 75px;
    line-height: 75px;
    .cut-line {
      color: #ccc;
      padding: 0 10px;
    }
    .build-mark {
      font-size: 24px;
      color: #7f7f7f;
      margin-top: 14px;
    }
    .build-name {
      font-size: 28px;
      font-weight: 600;
    }
  }
  .build-mark-name {
    font-size: 24px;
    color: #cccccc;
    text-align: center;
    margin-top: 8px;
  }
}
.create-build {
  position: fixed;
  left: 40px;
  bottom: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #4196ff;
  box-shadow: 0px 4px 12px 4px rgba(65, 150, 255, 0.5);
}
</style>
